import { render, staticRenderFns } from "./form-complete-standard.vue?vue&type=template&id=036eb2f3"
import script from "./form-complete-standard.vue?vue&type=script&lang=js"
export * from "./form-complete-standard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports